class HeroElementArrowDown {
    heroElement
    arrowDown
    firstMainContent

    constructor(heroElement) {
        this.heroElement = heroElement
        this.arrowDown = heroElement.querySelector('.js-hero-element-arrow-down')
        this.firstMainContent = document.querySelector('.main-content')

        if (!this.arrowDown) {
            return
        }

        this.checkHeroElementHeight() // Check on page load
        window.addEventListener('resize', () => {
            this.checkHeroElementHeight() // Check on window resize
        })
        document.addEventListener('afterHubSpotFormLoadedCompletelyEvent', () => {
            this.checkHeroElementHeight() // check after HubSpot form was loaded
        })
        this.arrowDown.addEventListener('click', () => {
            this.scrollToFirstMainContent() // Scroll to first main content on click of arrowDown
        })
    }

    checkHeroElementHeight() {
        if (this.heroElement.offsetHeight >= window.innerHeight - 80) {
            this.arrowDown.classList.add('show')
        } else {
            this.arrowDown.classList.remove('show')
        }
    }

    scrollToFirstMainContent() {
        this.firstMainContent.scrollIntoView({ behavior: 'smooth' })
    }
}

function initHeroElements() {
    const heroElements = document.querySelectorAll('.js-hero-element')

    heroElements.forEach((heroElement) => {
        new HeroElementArrowDown(heroElement)
    })
}

if (document.readyState !== 'loading') {
    initHeroElements()
} else {
    document.addEventListener('DOMContentLoaded', initHeroElements)
}
